import type { UserRecord } from '@/entities/user/model/userSchema';

/**
 * GET /api/admin/users — пользователи системы. Бэкенд: id, name, ad_login, role_code, org_unit, status.
 * role (отображаемое имя) и role_badge — вычисляются фронтом по role_code.
 */
export const userRecords: UserRecord[] = [
  {
    id: 1,
    name: 'Иванова П.С.',
    adLogin: 'p.ivanova',
    roleCode: 'ot_specialist',
    orgUnit: 'Все подразделения',
    status: 'ok',
  },
  { id: 2, name: 'Громов В.А.', adLogin: 'v.gromov', roleCode: 'admin', orgUnit: '—', status: 'ok' },
  { id: 3, name: 'Попов А.Д.', adLogin: 'a.popov', roleCode: 'department_head', orgUnit: 'Цех №1', status: 'ok' },
  { id: 4, name: 'Карпов Н.Р.', adLogin: 'n.karpov', roleCode: 'master', orgUnit: 'Цех №2, уч. 3', status: 'ok' },
  { id: 5, name: 'Мишина Е.Г.', adLogin: 'e.mishina', roleCode: 'viewer', orgUnit: 'ОТК', status: 'ok' },
  { id: 6, name: 'Зайцев О.В.', adLogin: 'o.zajcev', roleCode: 'viewer', orgUnit: 'Все подразделения', status: 'ok' },
  { id: 7, name: 'Фёдоров С.И.', adLogin: 's.fedorov', roleCode: 'employee', orgUnit: 'Цех №1', status: 'ok' },
];
